export const jobdesc = {
    "master": "Master",
    "operasional": "Manajer Store",
    "keuangan": "Manajer Keuangan",
    "inventaris": "Inventaris",
    "kasir": "Kasir",
};